import type { Earthquake } from '../api/schemas'

/** 全局警报状态机：整个指挥屏的主题联动以此为准 */
export type AlertPhase = 'IDLE' | 'WATCH' | 'ALERT' | 'CRITICAL'

/** 事件新鲜窗口：30 分钟内未关闭的事件才参与状态推导 */
const FRESH_WINDOW_MS = 30 * 60_000

export interface WaveLike {
  /** 后端 alert level：TAKE_ACTION / BE_AWARE，空为未知 */
  level?: string
}

/**
 * 状态推导（只用真实字段，不发明数据）：
 * - CRITICAL：传播中的波来自 TAKE_ACTION 级预警
 * - ALERT：传播中（BE_AWARE/未知级）或 30min 内有 TAKE_ACTION 活跃事件
 * - WATCH：30min 内存在未关闭事件
 * - IDLE：无活跃信号
 */
export function deriveAlertPhase(wave: WaveLike | null, quakes: Earthquake[]): AlertPhase {
  if (wave) return wave.level === 'TAKE_ACTION' ? 'CRITICAL' : 'ALERT'
  const now = Date.now()
  const fresh = quakes.filter((q) => {
    if (q.status === 'closed') return false
    const ts = Math.max(q.updatedAt || 0, q.createdAt || 0, q.originTime || 0)
    return ts > 0 && now - ts < FRESH_WINDOW_MS
  })
  if (fresh.some((q) => q.alertLevel === 'TAKE_ACTION')) return 'ALERT'
  if (fresh.length > 0) return 'WATCH'
  return 'IDLE'
}

export const PHASE_META: Record<AlertPhase, { label: string; order: number }> = {
  IDLE: { label: '值守', order: 0 },
  WATCH: { label: '关注', order: 1 },
  ALERT: { label: '警戒', order: 2 },
  CRITICAL: { label: '紧急', order: 3 },
}

export const PHASE_ORDER: AlertPhase[] = ['IDLE', 'WATCH', 'ALERT', 'CRITICAL']
